import { axios } from "../axios.instance";

export type PaySavedCardRequest = { orderId: string };

export type PaySavedCardResponse = {
  id: string;
};

export const paySavedCard = async (body: PaySavedCardRequest): Promise<PaySavedCardResponse> => {
  const { data } = await axios.post(`/payments/orders/${body.orderId}/pay`, body);

  return data;
};
